import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../login/auth.guard';
import { MainComponent } from './main.component';
import { DataComponent } from '../data/data.component';
import {ProjectComponent} from '../project/project.component';
import {SearchComponent} from '../search/search.component';

@NgModule({
  imports: [
    RouterModule.forChild([
        { path: 'main', component: MainComponent, canActivate: [AuthGuard]},
        { path: 'project',
            component: MainComponent,
            children : [
                {
                    path: ':id/:qid',
                    component: DataComponent
                },
                {
                  path: 'search',
                  component: SearchComponent
                },
                {
                  path: ':id',
                  component: ProjectComponent
                }
            ]
        }
    ])
  ],
  exports: [
    RouterModule
  ]
})
export class MainRoutingModule { }
